<template>
    <div>

        <section id="hero-usp">

            <div class="container">
                <div class="row text-left">
                    <div class="col-xs-12 col-sm-5">
                        <h2 class="s2">
                          Rapid Experimentation to Production Grade Stability

                        </h2>

                        <p class="white">
                          Skippr solves data pipeline headaches so you can launch and focus on value
                      </p>

                        <div class="mt-30">
                            <!--<form id="hero-register" method="post" action="/secure/registerquick.php"-->
                                  <!--class="form-inline">-->

                                <!--<div class="form-group input-group-lg">-->
                                    <!--<input type="email" placeholder="Email" required="" name="email" id="email"-->
                                           <!--class="form-control required"></div>-->
                                <!--<div class="form-group input-group-lg">-->

                                    <!--<button class="btn btn-secondary" type="submit">Free Trial</button>-->

                                <!--</div>-->
                            <!--</form>-->

<!--                          <a href="https://www.youtube.com/watch?v=k3N99DPbE9o" target="_blank" class="btn btn-secondary pull-left" type="submit">-->
<!--                            <font-awesome-icon :icon="['fa', 'play-circle']"/>-->
<!--                            Watch Demo</a>-->
                          <a href="/deploy-wizard" class="btn btn-secondary pull-left" v-on:click="clickEvent('try_now_free')">Try Now, Free</a>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-7 mt-30">
<!--                      <lottie-player src="https://assets1.lottiefiles.com/packages/lf20_eCi0yQ.json"  background="transparent"  speed="1"  style="width: 300px; height: 300px;"  loop  autoplay></lottie-player>-->

<!--                      :loopDelayMin="2.5"-->
<!--                      :loopDelayMax="5"-->
<!--                      @AnimControl="setAnimController"-->
                      <lottie-animation
                        path="animations/hero/data.json"
                        :loop="true"
                        :autoPlay="true"
                        :speed="1"

                      />
<!--                      :width="256"-->
<!--                      :height="256"-->


                    </div>

                </div>


            </div>
        </section>
    </div>
</template>


<script>

  import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

  export default {
      components: {
        LottieAnimation
      },
      name: 'Hero',
      props: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
